// extracted by mini-css-extract-plugin
module.exports = {"postMemory":"Post_postMemory__FBweB","postWMemory":"Post_postWMemory__woCus","post":"Post_post__92yvK"};